<main class="maintenance">
  <section class="maintenance__message">
    <h1>Parcours de souscription en maintenance</h1>
    <p>
      Notre service de souscription en ligne est momentanément indisponible en raison d'une opération de maintenance.
      Nous vous invitons à renouveler votre démarche ultérieurement.
    </p>
    <p>
      En cas de besoin, nous vous invitons à contacter nos conseillers au 0 970 15 77 77 (appel non surtaxé) du lundi
      au vendredi de 9h à 19h.
    </p>
  </section>
</main>
